import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';

const ManagerCommunityFinalThoughts = () => (
  <div className="space-y-8">
    <PlaybookSection title="Final Thoughts" icon={<SparklesIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="prose prose-invert max-w-none">
        <p className="text-lg">
          Building a successful people manager community of practice is about creating a space where managers can learn from each other, share experiences, and grow together. By following this playbook, you've established a foundation for sustainable growth and development of your management team. Remember that the true value comes from the community itself - your role is to facilitate and support, not to lead or control. Keep the focus on solving real problems and creating value for both managers and their teams.
        </p>
      </div>
    </PlaybookSection>
  </div>
);

export default ManagerCommunityFinalThoughts; 